<template>
  <v-app wrap>
    <div class="auth-wrapper auth-v1">
      <div class="auth-inner">
        <v-card class="auth-card">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click.native="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-title class="d-flex align-center justify-center py-7">
            <router-link to="/" class="d-flex align-center">
              <v-img
                :src="require('@/assets/images/logos/YEtVyDZe_400x400.jpg')"
                max-height="30px"
                max-width="30px"
                alt="logo"
                contain
                class="me-3"
              ></v-img>

              <h2 class="text-2xl font-weight-semibold">TUBES Kelompok 1</h2>
            </router-link>
          </v-card-title>
          <v-card-text>
            <p class="text-2xl font-weight-semibold text--primary mb-2">
              Welcome to TUBES Kelompok 1! 👋🏻
            </p>
            <p class="mb-2">
              Please sign-in to your account to continue anything :)
            </p>
          </v-card-text>
          <v-container fluid>
            <v-form ref="form">
              <v-text-field
                v-model="email"
                label="E-mail"
                required
                outlined
                placeholder="john@example.com"
                append-icon="mdi-email"
                class="mb-3"
              >
              </v-text-field>
              <v-text-field
                v-model="password"
                outlined
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                label="Password"
                placeholder="············"
                counter
                @click:append="showPassword = !showPassword"
              >
              </v-text-field>
              <div class="text-xs-center">
                <v-btn color="primary lighten-1" block @click="submit"
                  >Login<v-icon right dark>mdi-lock-open</v-icon>
                </v-btn>
              </div>
            </v-form>
          </v-container>
        </v-card>
      </div>
      <img
        class="auth-mask-bg"
        height="173"
        :src="
          require(`@/assets/images/misc/mask-${
            $vuetify.theme.dark ? 'dark' : 'light'
          }.png`)
        "
      />
      <!-- tree -->
      <v-img
        class="auth-tree"
        width="247"
        height="185"
        src="@/assets/images/misc/tree.png"
      ></v-img>

      <!-- tree  -->
      <v-img
        class="auth-tree-3"
        width="377"
        height="289"
        src="@/assets/images/misc/tree-3.png"
      ></v-img>
    </div>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      apiDomain: "https://demo-api-vue.sanbercloud.com",
    };
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setToken: "auth/setToken",
    }),
    close() {
      this.$emit("closed", false);
    },

    clearForm: function () {
      this.email = "";
      this.password = "";
    },

    submit() {
      const config = {
        method: "post",
        url: this.apiDomain + "/api/v2/auth/login",
        data: {
          email: this.email,
          password: this.password,
        },
      };

      this.axios(config)
        .then((response) => {
          this.clearForm();
          this.setToken(response.data.access_token);
          this.setAlert({
            status: true,
            color: "success",
            text: "Login Berhasil",
          });
          this.close();
        })
        .catch((response) => {
          console.log(response);
          this.setAlert({
            status: true,
            color: "error",
            text: "Login Gagal",
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "~@/plugins/vuetify/default-preset/preset/pages/auth.scss";
</style>